import { useSearchParams } from 'react-router-dom';
import { STATE } from '../../util/LocalStorage';

const JOIN_TOKEN_PARAM = 'joinToken';
export const JOIN_TOKEN_STATE_REGEX = /joinToken/g;

export const useJoinToken = () => {
    const [searchParams] = useSearchParams();
    let joinToken = searchParams.get(JOIN_TOKEN_PARAM);

    if (!joinToken) {
        const unparsedState = searchParams.get(STATE);
        if (unparsedState) {
            const states = unparsedState.split(JOIN_TOKEN_STATE_REGEX);
            joinToken = states[1] ? states[1] : null;
        }
    }

    const getJoinTokenAsQuery = (firstParam: boolean) => {
        const operator = firstParam ? '?' : '&';
        if (!joinToken) return '';
        return `${operator}${JOIN_TOKEN_PARAM}=${joinToken}`;
    };

    const joinTokenForState = joinToken ? `${JOIN_TOKEN_PARAM}${joinToken}` : '';

    return { joinToken, getJoinTokenAsQuery, joinTokenForState };
};
